import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { wsGetAll } from 'services/WService.js';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;

  const [dataImport, setDataImport] = useState({});
  const [sellers, setSellers] = useState([]);

  const [openModalBPartner, setOpenModalBPartner] = useState(false); //Abrir modal
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);


  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listSeller() {
    let response = await wsGetAll('sale/seller-quote-winter/sellers-bureau');
    if (response.success) setSellers(response.data);
  }

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (dataImport?.success) {
      console.log("Importación exitosa", dataImport);
  
      setDataChanging((prev) => ({
        ...prev,
        SlpCode: null,
      }));
  
      setBPartnerSelect({
        success: dataImport.success,
        customers: dataImport.data.map((item) => {
          return {
            SlpCode: item.CODIGOVENDEDOR,
            ClientesEfectivos: item.CLIENTES,
            NumeroPedidos: item.NROPEDIDOS,
            ItemXPedido: item.ITEMPEDIDO,
            TMLUC: item.TMLUC,
            Galletas: item.GALLETAS,
            Chocolate: item.CHOCOLATE,
            Cafe: item.CAFE,
            CuotaSolesTotal: item.CUOTASOLES,
          };
        }),
        SlpName: dataImport.nameFile,
      });
    } else if (dataImport?.success === false) {
      console.log("Importación fallida", dataImport);
      setBPartnerSelect(undefined);
    }
  }, [dataImport]);

  useEffect(() => {
    if (bPartnerSelect?.SlpCode) {
      setDataChanging((prev) => ({
        ...prev,
        SlpCode: bPartnerSelect?.SlpCode || '',
      }));
    }
  }, [bPartnerSelect]);

    useEffect(() => {
      if (customerPortfolioB.open) {
        if (!customerPortfolioB.id) listSeller();
        setDataChanging(customerPortfolioB);
      }
    }, [customerPortfolioB.open]);

  return (
    <>
      <Modal
        title={`Nueva Cuota de Vendedor`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={
          dataChanging.SlpCode
            ? 'sale/seller-quote-winter'
            : 'sale/seller-quote-winter/multiple'
        }
        dataForce={
          dataChanging.SlpCode
            ? {
                SlpCode: dataChanging.SlpCode,
                ClientesEfectivos: dataChanging.ClientesEfectivos,
                NumeroPedidos: dataChanging.NumeroPedidos,
                ItemXPedido: dataChanging.ItemXPedido,
                TMLUC: dataChanging.TMLUC,
                Galletas: dataChanging.Galletas,
                Chocolate: dataChanging.Chocolate,
                Cafe: dataChanging.Cafe,
                CuotaSolesTotal: dataChanging.CuotaSolesTotal,
              }
            : {
                SlpCode: cuota.valueSearch?.SlpCode,
                customers: bPartnerSelect?.customers,
                force: 'N'
              }
        }
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <span style={{ display: 'flex', alignItems: 'flex-end' }}>
          <Autocomplete
            disableClearable
            options={sellers}
            getOptionLabel={(item) => `${item.SlpName} (Código: ${item.SlpCode})`}
            renderInput={(params) => (
              <TextField {...params} label="Vendedor" margin="normal" fullWidth />
            )}
            onChange={(e, item) => {handleChange('SlpCode', item?.SlpCode); setDataImport(null);}}
            value={sellers.find((seller) => seller.SlpCode === dataChanging.SlpCode) || null}
            style={{ flexGrow: 1, marginRight: '10px' }}
          />
          <ImportExcel
            setDataImport={setDataImport}
            btnColor="success"
            validDuplicate="CODIGOVENDEDOR"
            sortDuplicate="CODIGOVENDEDOR"
            downTemplate={{
              fileNameDown: `${moment(cuota?.valueSearch?.Periodo).format('YYYY-MM')}_Plantilla de cuota para Vendedor`,
              fields: ['CODIGOVENDEDOR','CLIENTES','NROPEDIDOS','ITEMPEDIDO','TMLUC','GALLETAS','CHOCOLATE','CAFE','CUOTASOLES']
            }}
          />
        </span>
        {dataImport?.success && (
          <p style={{ color: '#07c107', marginTop: '10px', fontSize: '14px' }}>
            Archivo importado: {dataImport.nameFile}
          </p>
        )}
        {dataChanging.SlpCode ? (
          <>
            <TextField
              label="Clientes Efectivos"
              fullWidth
              type="number"
              name="ClientesEfectivos"
              margin="normal"
              value={dataChanging.ClientesEfectivos || ''}
              onChange={(e) => handleChange('ClientesEfectivos', e.target.value)}
              required
            />
            <TextField
              label="Número de pedido"
              fullWidth
              type="number"
              name="NumeroPedidos"
              margin="normal"
              value={dataChanging.NumeroPedidos || ''}
              onChange={(e) => handleChange('NumeroPedidos', e.target.value)}
              required
            />
            <TextField
              label="Item por pedido"
              fullWidth
              type="number"
              name="ItemXPedido"
              margin="normal"
              value={dataChanging.ItemXPedido || ''}
              onChange={(e) => handleChange('ItemXPedido', e.target.value)}
              required
            />
            <TextField
              label="TMLUC"
              fullWidth
              type="number"
              name="TMLUC"
              margin="normal"
              value={dataChanging.TMLUC || ''}
              onChange={(e) => handleChange('TMLUC', e.target.value)}
              required
            />
            <TextField
              label="Galletas"
              fullWidth
              type="number"
              name="Galletas"
              margin="normal"
              value={dataChanging.Galletas || ''}
              onChange={(e) => handleChange('Galletas', e.target.value)}
              required
            />
            <TextField
              label="Chocolate"
              fullWidth
              type="number"
              name="Chocolate"
              margin="normal"
              value={dataChanging.Chocolate || ''}
              onChange={(e) => handleChange('Chocolate', e.target.value)}
              required
            />
            <TextField
              label="Cafe"
              fullWidth
              type="number"
              name="Cafe"
              margin="normal"
              value={dataChanging.Cafe || ''}
              onChange={(e) => handleChange('Cafe', e.target.value)}
              required
            />
            <TextField
              label="Total de Cuota en Soles"
              fullWidth
              type="number"
              name="CuotaSolesTotal"
              margin="normal"
              value={dataChanging.CuotaSolesTotal || ''}
              onChange={(e) => handleChange('CuotaSolesTotal', e.target.value)}
              required
            />
          </>
        ) : undefined}
      </Modal>
    </>
  );
});
